rs.module("controls/components/delete-prompt",

    [
        "ui/framework/client-templates"
    ],

    function (clientTemplates) {

        var _onDeleteInitiatedCallback;
        var _onDeleteSuccessCallback;
        var _onDeleteFailCallback;
        var _additionalHeaders;

        // Initialize
        function initialize(selector, position, templateKey) {

            $(document).on("click", selector, function (event) {
                event.preventDefault();

                // If this is a form submit button, validate the form and make sure it's valid before
                // continuing.
                if ($(this).is("button[type='submit']") && !$(this).closest("form").validate().form()) {
                    return;
                }

                // If set to skip the prompt on mobile, immediately execute delete if on mobile sized screen
                // OR if set to skip the prompt altogther, immediately execute delete
                if ($(this).is('[data-skippromptonmobile="true"]') && $.isMobile() || $(this).is('[data-skipprompt="true"]')) {
                    executeDelete($(this));
                } else {
                    showPrompt($(this), position, templateKey);
                }
            });
        }

        // Show the toolbar delete prompt
        function showPrompt(deleteElement, position, templateKey) {

            // Toolbar is the sibling immediately following this delete
            var promptPopup = $(clientTemplates.render(templateKey));

            // Position it
            $("body").append(promptPopup);
            promptPopup.css("left", (deleteElement.offset().left) + "px");
            promptPopup.css("top", (deleteElement.offset().top) + "px");
            promptPopup[0].style.setProperty('--delete-element-height', (deleteElement[0].getBoundingClientRect().height + "px"));
            promptPopup[0].style.setProperty('--delete-element-width', (deleteElement[0].getBoundingClientRect().width + "px"));
            promptPopup[0].style.setProperty('--delete-prompt-height', (promptPopup[0].getBoundingClientRect().height + "px"));
            promptPopup[0].style.setProperty('--delete-prompt-width', (promptPopup[0].getBoundingClientRect().width + "px"));
            promptPopup.toggleClass(position, true);
            promptPopup.toggleClass("_visible", true);

            // give focus to the first button in the prompt if it was triggered by the keyboard
            if (whatInput.ask() === "keyboard") {
                promptPopup.find("button").first().trigger("focus");
            }

            // If we click anywhere outside the prompt, hide the prompt
            $(document).on(`mouseup`, function (e) {
                if (!promptPopup.is(e.target) && promptPopup.has(e.target).length === 0) {
                    destroyPrompt(promptPopup);
                }
            });

            // Handle the delete
            promptPopup.on(`click enterpressed`, "._delete", function () {

                // Prevent clicking any more buttons
                $(this).siblings("button").addBack().prop("disabled", true);

                executeDelete(deleteElement, promptPopup);
                deleteElement.trigger("focus");
            });

            // Cancel button hides the prompt
            promptPopup.on(`click enterpressed tabforward`, "._cancel", function () {
                destroyPrompt(promptPopup);
                deleteElement.trigger("focus");
            });

            // Handle the delete
            promptPopup.on(`tabbackward`, "._delete", function (event) {
                destroyPrompt(promptPopup);
                deleteElement.trigger("focus");
                event.preventDefault();
            });
        }

        // Perform the delete
        function executeDelete(deleteElement, promptPopup) {

            // A link (should have an href for the backend DELETE action)
            if (deleteElement.is("a")) {

                // If initiate callback has been defined execute it
                if (_onDeleteInitiatedCallback) {
                    executeCallback(_onDeleteInitiatedCallback);
                }

                var headers = { /* any headers that need to be on the delete request go here - currently we don't have a need for any */ };
                if (_additionalHeaders) {
                    // if headers were specified by the caller, merge those into our exisitng headers
                    $.extend(headers, _additionalHeaders);
                }

                $.ajax({
                    url: deleteElement.attr("href"),
                    type: "DELETE",
                    delayInformationalMessages: true,
                    headers: headers
                })
                    .done(function (_, __, xhr) {

                        // Ajax redirect
                        if (xhr.status == 202) {
                            window.location = xhr.getResponseHeader("location");
                        }
                        // Stay on page (no reload/redirect)
                        else if (xhr.status == 204) {
                            destroyPrompt(promptPopup);

                            // If success callback has been defined execute it
                            if (_onDeleteSuccessCallback) {
                                executeCallback(_onDeleteSuccessCallback);
                            }
                        }
                        // Success, just reload
                        else {
                            // Reload the current url.  We do not use window.location.reload() becuase that will cause
                            // a POST if the current page was loaded via a POST.  We want a GET, so will just re-set the 
                            // window location
                            window.location = window.location.href;
                        }
                    })
                    .fail(function (xhr, _, error) {

                        console.log(error || xhr.responseJSON || "A error occurred while processing the delete.");

                        destroyPrompt(promptPopup);

                        // If failure callback has been defined execute it
                        if (_onDeleteFailCallback) {
                            executeCallback(_onDeleteFailCallback, error);
                        }
                    });
            }
            // Form submit button - just submit the form
            else if (deleteElement.is("button[type='submit']")) {

                // If initiate callback has been defined execute it
                if (_onDeleteInitiatedCallback) {
                    executeCallback(_onDeleteInitiatedCallback);
                }

                deleteElement.closest("form").submit();
            }
            else {
                throw new Error("Invalid delete link UI element.");
            }

            // Helper function to execute a callback with arguments
            function executeCallback(callbackFunction, error) {
                callbackFunction.call(
                    null,
                    deleteElement,
                    {
                        popup: promptPopup,
                        destroy: function () {
                            destroyPrompt(promptPopup)
                        }
                    },
                    error
                );
            }
        }

        // Destory the toolbar delete prompt
        function destroyPrompt(promptPopup) {

            // Hide the prompt and when the css fade ends remoe it from the DOM entirely
            if (promptPopup) {
                promptPopup
                    .toggleClass("_visible", false)
                    .on("transitionend", function () { promptPopup.remove(); });
            }
            
        }

        //
        // API function to allow consumers to provide a call back function to execute after a successful delete
        //
        function onDeleteSuccess(onDeleteSuccessCallback) {
            _onDeleteSuccessCallback = onDeleteSuccessCallback;
        }

        //
        // API function to allow consumers to provide a call back function to execute if a delete fails
        //
        function onDeleteFailure(onDeleteFailCallback) {
            _onDeleteFailCallback = onDeleteFailCallback;
        }

        //
        // API function to allow consumers to provide a call back function to execute when a delete is initiated (before it sends)
        //
        function onDeleteInitiated(onDeleteInitiatedCallback) {
            _onDeleteInitiatedCallback = onDeleteInitiatedCallback;
        }

        //
        // API function to allow consumers to provide headers to be included on the delete request
        //
        function headers(headers) {
            _additionalHeaders = headers;
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            onDeleteInitiated: onDeleteInitiated,
            onDeleteSuccess: onDeleteSuccess,
            onDeleteFailure: onDeleteFailure,
            headers: headers
        };

        return exports;
    }
);